import { VITIMAS_CADAS_TRADAS } from '../../../dominio/tabletop/atendimento'

interface Props {
  readonly idFichaAtual: string | null
  readonly onVincularFicha: (idFicha: string | null) => void
  readonly rotulo?: string
}

const VALOR_SEM_FICHA = ''

/**
 * Escolha explícita da ficha clínica de um manequim. Não há ficha "sugerida":
 * sem escolha, a vítima fica como "ficha não configurada" — nunca herda a
 * ficha de outra só pela posição na lista.
 */
export function SeletorFichaVitima(p: Props) {
  return (
    <label className="campo">
      <span>{p.rotulo ?? 'Ficha clínica'}</span>
      <select
        value={p.idFichaAtual ?? VALOR_SEM_FICHA}
        onChange={(e) => p.onVincularFicha(e.target.value === VALOR_SEM_FICHA ? null : e.target.value)}
      >
        <option value={VALOR_SEM_FICHA}>(sem ficha clínica configurada)</option>
        {VITIMAS_CADAS_TRADAS.map((f) => (
          <option key={f.id} value={f.id}>
            {f.titulo}
          </option>
        ))}
      </select>
    </label>
  )
}
